import {ImageUrlString} from '../../classes/images/imageUrl';
import {browserSupportsWebP} from './browserSupportsWebP';
import {convertImageUrlToWebP} from './convertImageUrlToWebP';

/**
 * @name convertImageUrlToWebPIfSupported
 */
export const convertImageUrlToWebPIfSupported = (
  url: string
): ImageUrlString | string => {
  if (browserSupportsWebP()) {
    return convertImageUrlToWebP(url);
  }

  return url;
};
